import { ProductSpec } from "../interface"

export const powerArQMax: ProductSpec = {
  id: 'pa200',
  name: 'PowerArQ Max',
  url: process.env.GATSBY_TARGET_CHANNEL === 'rakuten' ? "https://item.rakuten.co.jp/kashima-tokeiten/pa200/" : "https://powerarq.com/products/pa200",
  capacity: 2150,
  colors: [
    'coyote-tan',
    'olive-drab'
  ],
  defaultColor: 'olive-drab',
  price: 264000,
  description: '2,150Wh・通常2,000W最大4,800Wの大型モデル。ヘアドライヤーやホットカーペット、小型電気ポッドやホットプレートの高出力な家電も利用することが可能',
  chargingTime: 6,
  chargingTimeWithDual: 3,
  chargingTimeWithSolar: { input: 150, value: 4 },
  batteryType: 'リン酸鉄',
  maximumOutput: 2000,
  smartphone: 170,
  electricBlanket: 34,
  fan: 57,
  ledLight: 567,
  riceCooker: 7,
  fridge: 28,
  electricCarpet: 9,
  electricPod: 2,
  drill: {
    value: 2,
    override: {
      unit: '時間'
    }
  },
  hairDryer: 1.5,
  hotPlate: 1.3,
  acPort: 6,
  usbA: 4,
  usbC: 1,
  qi: 2,
  builtInLed: 1622,
  weight: 28.2
}